import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MetaService } from './Service/meta.service';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  seoData: any;
  companyCode: string = environment.companyCode;
  logoName: string = environment.logoName;
  constructor(
    private metaServiceData: MetaService,
    private title: Title, private meta: Meta)
  {
  }
   
  ngOnInit(): void {
    this.setFavicons();
    this.updateMetaTags();
  }

  private setFavicons(): void {
    const basePath = `assets/images/${this.companyCode}`;

    this.setHref('favicon-png', `${basePath}/Logo/${this.logoName}.png`);
    this.setHref('favicon-svg', `${basePath}/favicon/${this.logoName}.svg`);
    this.setHref('favicon-ico', `${basePath}/favicon/${this.logoName}.ico`);
    this.setHref('favicon-apple', `${basePath}/favicon/${this.logoName}.png`);
  }

  private setHref(id: string, href: string): void {
    const link = document.getElementById(id) as HTMLLinkElement;
    if (link) {
      link.href = href;
    }
  }
  updateMetaTags() {
    this.seoData = this.metaServiceData.getSeo("index-page", "");
    if (this.seoData) {
      this.title.setTitle(this.seoData.Title);
      this.meta.updateTag({ name: 'description', content: this.seoData.metaDescription });
      this.meta.updateTag({ name: 'keywords', content: this.seoData.metaKeyword });
      this.meta.updateTag({property: 'og:title', content: this.seoData.Title});
      this.meta.updateTag({property: 'og:description', content: this.seoData.metaDescription});
      //this.meta.updateTag({property: 'og:image',content: environment.ogImage || 'assets/images/og-image.png'});
      this.meta.updateTag({property: 'og:url',content: environment.DomainUrl});
    }
  }
}
